import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { ScrollContainer } from '../../scroll-container/ScrollContainer';
import styles from './AccordionMenu.module.scss';

export const AccordionMenu = ({
    children, active, className, maxHeight = 360
}: Props) => {

    if (!active) {
        return null;
    }

    const classes = classNames(className, styles.default);

    return (
        <ScrollContainer maxHeight={maxHeight} className={classes}>
            {children}
        </ScrollContainer>
    );
};

type Props = PropsWithChildren<{
    active: boolean;
    className?: string;
    maxHeight?: string | number;
}>;